/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: "/concedentes",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "concedentes_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Concedentes", to: "concedentes_list" }],
          permission: "concedente:view",
          title: "Concedentes",
        },
      },
      {
        name: "concedentes_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "Concedentes", to: "concedentes_list" }],
          permission: "concedente:create",
          title: "Concedentes - Cadastro",
        },
      },
      {
        name: "concedentes_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "Concedentes", to: "concedentes_list" }],
          permission: "concedente:edit",
          title: "Concedentes - Edição",
        },
      },
      {
        name: "concedentes_contatos_edit",
        path: "editar/:concedente_id/contato_id/:id",
        component: () =>
          import("@/modules/concedentes_contatos/pages/Edit.vue"),
        meta: {
          breadcrumbs: [{ label: "Concedentes", to: "concedentes_list" }],
          permission: "concedente:edit",
          title: "Concedentes - Edição de Contatos",
        },
      },
    ],
  },
];
